import React from 'react'
import AboutUs from '../about-us'

const AboutUsFr = () => {
    return <AboutUs languageCode="fr" />
}

export default AboutUsFr
